import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import * as React from "react";
import styled from "styled-components";
export var ResultDropdownDeleteButton = function(param) {
    var onDelete = param.onDelete, isDeleting = param.isDeleting, ariaLabel = param.ariaLabel, className = param.className;
    if (isDeleting) {
        /*loading state for delete button*/ return /*#__PURE__*/ _jsx(StyledDeleteButton, {
            className: className,
            children: /*#__PURE__*/ _jsx(LoadingSpinner, {
                size: "small",
                "data-test-id": "deleting-search"
            })
        });
    } else {
        return /*#__PURE__*/ _jsx(StyledDeleteButton, {
            className: className,
            onClick: function(event) {
                event.stopPropagation();
                event.preventDefault();
                onDelete();
            },
            // Prevent ResultsDropdown from closing when clicking delete button
            onMouseDown: function(event) {
                return event.preventDefault();
            },
            "aria-label": ariaLabel,
            tabIndex: -1,
            children: /*#__PURE__*/ _jsx(Close, {})
        });
    }
};
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/IconButton/IconButton#IconButton"
 */ var StyledDeleteButton = styled.button.withConfig({
    componentId: "sc-d0f60480-0"
})([
    "display:flex;align-content:center;color:",
    ";&:hover{color:",
    ";}"
], Core.text.subdued, Core.text.default);
